<template>
  <div id="flash-message" v-bind:class="type" v-if="show" ref="elem">
    <div class="message" v-html="$t(message)" />
    <div class="close" @click="() => hide()">
      <div class="line line-1" />
      <div class="line line-2" />
    </div>
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api';
import { TweenMax } from 'gsap';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

const { useState, useActions } = createNamespacedHelpers('flash');

export default {
  name: 'FlashMessage',
  components: {},
  setup() {
    const { isActive, message, type } = useState(['isActive', 'message', 'type']);
    const { setActiveStatus } = useActions(['setActiveStatus']);
    const show = ref(false);
    const elem = ref(null);

    const hide = () => {
      setActiveStatus(false);
    };

    watch(isActive, (newVal) => {
      if (elem.value) {
        if (newVal) {
          show.value = newVal;
        }

        TweenMax.to(elem.value, .2, {
          opacity: +newVal,
          onComplete: () => {
            if (!newVal) {
              show.value = newVal;
            }
          }
        });
      } else {
        show.value = newVal;
      }
    }, {
      immediate: true
    });

    return {
      elem,
      show,
      message,
      type,
      hide
    };
  }
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/colors";

#flash-message {
  position: fixed;
  top: 15px;
  right: 10px;
  max-width: 400px;
  min-width: 200px;
  border-radius: 4px;
  min-height: 40px;
  background-color: $independence;
  color: $babyPowder;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  font-weight: bold;
  padding: 12px 30px;
  padding-bottom: 15px;
  padding-right: 50px;
  z-index:9999;
  transition: all 0.2s;
  box-shadow: 0px 3px 3px $shadow;

  .close {
    position: absolute;
    top: 13px;
    right: 15px;
    width: 15px;
    height: 15px;
    cursor: pointer;
    opacity: .5;
    transition: all .2s ease-in-out;

    .line {
        height: 2px;
        width: 15px;
        background-color: $babyPowder;
        transform-origin: center;
        margin: 0 auto;
        transition: all .2s ease-in-out;
    }

    .line-1 {
        transform: translateY(9px) rotate(45deg);
    }

    .line-2 {
        transform: translateY(7.25px) rotate(135deg);
    }

    &:hover {
      opacity: 1;
    }
  }

  @media (max-width: 767px) {
    width: calc(100% - 30px);
  }

  &.info {
    background-color: $independence;
  }

  &.error {
    background-color: $geranium;
  }
}
</style>
